import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.379 66.781h73.223c.54 0 .96-.559.86-1.16-.239-1.5-.38-3.02-.38-4.559v-5c0-14.46-10.738-26.699-25.578-30.859v-8.64c0-.899-.738-1.641-1.64-1.641H53V6.399h4.601c.84 0 1.52-.68 1.52-1.52V1.52c0-.84-.68-1.519-1.52-1.519H41.704c-.84 0-1.52.68-1.52 1.52v3.34c0 .84.68 1.519 1.52 1.519h4.602v8.54h-6.86c-.898 0-1.64.737-1.64 1.64v8.8C23.302 29.7 12.88 41.802 12.88 56.04v5c0 1.54-.14 3.06-.38 4.56-.077.62.34 1.183.88 1.183zM6.941 81h86.102c.762 0 1.16-1.02.66-1.64a31.2 31.2 0 0 1-4.359-7.262c-.14-.34-.46-.578-.8-.578H11.44c-.34 0-.64.218-.8.578a29.7 29.7 0 0 1-4.36 7.261C5.781 80 6.18 81 6.941 81M99.539 91.199c-.781-3.379-3.879-5.719-7.398-5.719H7.86c-3.52 0-6.621 2.36-7.399 5.719-.3 1.281-.46 2.602-.46 3.922v1.398c0 1.922 1.62 3.461 3.62 3.461h92.762c2 0 3.621-1.558 3.621-3.46v-1.4a17.4 17.4 0 0 0-.464-3.921z" }, null, -1)
  ]))]))
}
export default { render: render }